import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
                </div>
              )}
              {isLast ? (
                <span className="text-foreground-600 font-medium" aria-current="page">
                  {item.label}
                </span>
              ) : item.href ? (
                <Link
                  to={item.href}
                  className="text-foreground-400 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-500">{item.label}</span>
              )}
            </li>
          );
        })}
      </ol>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: items.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.label,
            item: item.href ? `https://lejiabaoli.cn${item.href}` : undefined,
          })),
        })}
      </script>
    </nav>
  );
}